import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const AUDIENCE = process.env.REACT_APP_AUTH0_AUDIENCE;

export const SESSION_TOKEN_KEY = "session_token";

/**
 * Distinguish "the user is (no longer) authenticated" from "the backend
 * hiccuped". Only the former should ever trigger a logout — a Cloud Run cold
 * start, a rate-limited Auth0 /userinfo call (backend returns 400) or a 5xx
 * must NOT throw the user back to the login screen.
 */
export function isUnauthenticatedError(error) {
  const auth0Code = error?.error;
  if (
    auth0Code === "login_required" ||
    auth0Code === "consent_required" ||
    auth0Code === "missing_refresh_token"
  ) {
    return true;
  }
  return error?.response?.status === 401;
}

/**
 * Single source of truth for turning the Auth0 access token into our own
 * backend session token. Stores the token for the axios interceptor and
 * returns the user profile. Throws on failure (caller decides how to react).
 */
export async function establishBackendSession(getAccessTokenSilently) {
  const accessToken = await getAccessTokenSilently({
    authorizationParams: { audience: AUDIENCE },
  });

  const { data } = await axios.post(`${API}/auth/callback`, {
    access_token: accessToken,
  });

  if (data?.session_token) {
    localStorage.setItem(SESSION_TOKEN_KEY, data.session_token);
    axios.defaults.headers.common["Authorization"] = `Bearer ${data.session_token}`;
  }
  return data?.user ?? null;
}

export function hasBackendSession() {
  return Boolean(localStorage.getItem(SESSION_TOKEN_KEY));
}

export function clearBackendSession() {
  localStorage.removeItem(SESSION_TOKEN_KEY);
  delete axios.defaults.headers.common["Authorization"];
}
